import type { $Fetch } from 'ofetch';
import type { HistoricoEscolarGateway } from '@/application/port/out/HistoricoEscolarGateway';
import type { HistoricoEscolar } from '@/domain/model/HistoricoEscolar';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/**
 * HTTP gateway pra Historico Escolar. Authority: assessment:historico:read.
 *
 * @since G.5.7
 */
export class HttpHistoricoEscolarGateway implements HistoricoEscolarGateway {
  constructor(private readonly client: $Fetch) {}

  async getByAluno(alunoId: string): Promise<HistoricoEscolar> {
    const res = await this.client<ApiResponse<HistoricoEscolar>>(
      `/api/v1/alunos/${encodeURIComponent(alunoId)}/historico-escolar`,
      { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }
}
